<template>
    <div>
        <div class="text-nowrap" v-if="displayClassement">
            {{ classement }}

            <v-icon class="icon_differentiel differentiel_up" name="arrow-up" aria-hidden="true"
                v-if="differentiel > 0" />
            <v-icon class="icon_differentiel differentiel_down" name="arrow-down" aria-hidden="true"
                v-else-if="differentiel < 0" />
            <v-icon class="icon_differentiel differentiel_equal" name="equals" aria-hidden="true" v-else />
            <span class="val_differentiel" v-if="displayDifferentiel">{{
                Math.abs(differentiel) }}</span>
        </div>
        <div v-else>-</div>
    </div>
</template>

<script>
export default {
    props: ['classement', 'differentiel'],
    computed: {
        displayClassement() {
            return this.classement && this.classement !== '0' && this.classement !== 0 && this.classement !== '';
        },
        displayDifferentiel() {
            return this.differentiel && this.differentiel !== 0;
        }
    }

}
</script>

<style lang="scss" scoped></style>